// @flow
const Logger = require('js-logger')

// const sentryHandler = (sentry, messages, context) => {
//   const { level = { name: 'INFO' } } = context

//   if (level.name === 'ERROR') {
//     const error = messages[0] || messages
//     const errorInfo = {
//       ...{
//         sentry: true,
//       },
//       ...(messages[1] || {}),
//     }

//     sentry.loggerHandler(error, errorInfo)
//   }
// }

export function initLogger() {
  Logger.useDefaults()
  const consoleHandler = Logger.createDefaultHandler()

  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BETA !== 'true') {
    Logger.setLevel(Logger.INFO)
  } else {
    Logger.setLevel(Logger.DEBUG)
  }

  Logger.setHandler((messages, context) => {
    // eslint-disable-line
    consoleHandler(messages, context)

    if (process.env.REACT_APP_EXTERNAL === 'false') {
      // import(/* webpackMode: "eager" */ 'core/services/sentry')
      //   .then(({ Sentry }) => {
      //     sentryHandler(Sentry, messages, context)
      //     return true
      //   })
      //   .catch(error => console.error(error)) // eslint-disable-line
    }
  })

  return true
}

export { Logger }

export default Logger
